<app-nav-menu></app-nav-menu>
<div class="ticker-wrap" >
  <div class="ticker-heading">News Alert</div>
  <div class="ticker">
    <ul style="display: flex">
      @for (news of activeNews; track news) {
        <li>
          <a style="color: black" target="_blank" href="{{news.newsLink}}">
            <i class="uil uil-globe news_bar_icons ticker__item"></i> {{news.newsDescription}}
          </a>
        </li>
      }
    </ul>
  </div>
</div>

<p-toast></p-toast>
<main class="main">
  <div class="b2bContainer mainSection">
    <div class="row">
      <div class="col-sm-12" style="width:100%">
        <form action=""
          class="main_form"
          #flightSearchForm="ngForm"
          (ngSubmit)="flightSearchValidation(flightSearchForm)">
          <!-- Tab panes -->

          <div class="main_card">

            <!-- 1st Tab -->
            <div id="searchFlights searchbar"
              class="searchFlights-methods-tabcontent"
              style="display: block">

              <div class="searchtab">

                <span class="search-type-tab active" id="searchFlights-methods-tablinks" [class.active]="selectedMainDiv === 1"
                  (click)="searchFlightsMethod(1)">


                  <svg viewBox="0 0 37 21" fill="orange" xmlns="http://www.w3.org/2000/svg" class="product-icon" style="
    fill: orange !important;
">
                    <path d="M35.2934 1.03321C34.0582 0.582706 32.7434 0.391651 31.4311 0.471969C30.1188 0.552288 28.8371 0.902253 27.6661 1.50003L10.7289 9.83228L6.72037 7.06197C6.07289 6.61491 5.3252 6.33431 4.54346 6.245C3.76172 6.15569 2.97001 6.26044 2.23838 6.54994L0.448242 7.25748L7.44388 12.9364C8.33869 13.6714 9.46755 14.0607 10.6252 14.0337C10.9162 14.0333 11.2049 13.981 11.4777 13.8794L18.4906 11.1782L18.5212 11.1902L19.129 9.58358L26.6207 6.62573L25.6764 8.25761L35.336 4.43261C35.6775 4.29584 35.9697 4.05887 36.174 3.75287C36.3783 3.44688 36.4852 3.08622 36.4806 2.71832C36.476 2.35042 36.3601 1.99254 36.1482 1.69176C35.9363 1.39098 35.6383 1.16139 35.2934 1.03321Z" fill="#E5F5FD"></path>
                    <path d="M2.23838 8.05056C2.97001 7.76106 3.76172 7.65634 4.54346 7.74565C5.3252 7.83496 6.07289 8.11554 6.72038 8.56259L10.2754 11.0204C10.4128 11.1156 10.5732 11.1724 10.7399 11.1848C10.9066 11.1972 11.0737 11.1647 11.2236 11.0909L18.2313 7.64093L22.8928 5.34541L27.6634 2.99668C28.8344 2.3989 30.1161 2.04894 31.4284 1.96862C32.7408 1.8883 34.0556 2.07935 35.2908 2.52986C35.5208 2.61062 35.7318 2.73776 35.9107 2.90339C36.0896 3.06902 36.2326 3.26961 36.3308 3.49276C36.4352 3.256 36.4891 3.00008 36.4891 2.74132C36.4933 2.36659 36.3801 1.99994 36.1655 1.69275C35.9508 1.38555 35.6454 1.15322 35.2921 1.02833C34.0569 0.577823 32.7421 0.386768 31.4298 0.467087C30.1174 0.547405 28.8358 0.897371 27.6647 1.49515L22.8941 3.84388L18.2326 6.1394L10.7302 9.83272L6.7217 7.0624C6.07422 6.61535 5.32654 6.33475 4.54479 6.24544C3.76305 6.15613 2.97134 6.26087 2.23971 6.55037L0.448242 7.25791L1.69176 8.26736L2.23838 8.05056Z" fill="#B9C8DB"></path>
                    <path d="M22.8933 3.84314L18.2318 6.13866L11.9424 2.08625L14.2645 0.673828L22.8933 3.84314Z" fill="#43CAF9"></path>
                    <path d="M20.9343 4.78695L12.993 1.41016L11.9424 2.08577L18.2318 6.13819L20.9343 4.78695Z" fill="#29C2F8"></path>
                    <path d="M20.0341 5.23765L12.6195 1.63477L11.9438 2.08561L18.2333 6.13804L20.0341 5.23765Z" fill="#00B8F8"></path>
                    <path d="M26.6216 6.62695L25.6773 8.25883L19.0488 19.7059H15.3022L18.5221 11.1941L19.1299 9.58746L26.6216 6.62695Z" fill="#43CAF9"></path>
                    <path d="M21.9833 8.53418L19.2808 9.58485L18.673 11.1915L15.4531 19.7033H16.8802L21.9833 8.53418Z" fill="#29C2F8"></path>
                    <path d="M20.632 9.05957L19.2808 9.59155L18.673 11.1982L15.4531 19.71H16.1288L20.632 9.05957Z" fill="#00B8F8"></path>
                    <path d="M35.4436 0.603739C34.1511 0.134217 32.776 -0.0649618 31.4034 0.0185389C30.0308 0.10204 28.6899 0.466439 27.4638 1.08917L22.8675 3.35012L14.4195 0.2473C14.3558 0.22392 14.2877 0.215253 14.2202 0.221933C14.1527 0.228612 14.0876 0.250473 14.0298 0.285878L11.7077 1.6983C11.6425 1.73798 11.5885 1.79354 11.5507 1.85979C11.5129 1.92603 11.4925 2.00079 11.4914 2.07706C11.4904 2.15333 11.5087 2.22863 11.5446 2.2959C11.5806 2.36317 11.633 2.42022 11.697 2.4617L17.3162 6.0832L10.7687 9.30971L6.97831 6.68967C6.27068 6.19946 5.45288 5.89171 4.59762 5.7938C3.74237 5.69588 2.87617 5.81083 2.07605 6.12843L0.284582 6.8373C0.211509 6.86629 0.147287 6.91389 0.0982883 6.97537C0.0492893 7.03684 0.0172158 7.11006 0.00525174 7.18776C-0.00671232 7.26546 0.0018482 7.34494 0.0300836 7.41831C0.0583191 7.49168 0.105249 7.55639 0.166215 7.60602L7.16185 13.285C8.10032 14.0531 9.27407 14.4756 10.4868 14.482H10.6384C10.9805 14.4799 11.3196 14.4173 11.6399 14.2971L17.7577 11.9417L14.8837 19.5425C14.8578 19.6107 14.8489 19.6842 14.8578 19.7566C14.8666 19.8291 14.8929 19.8983 14.9343 19.9583C14.9758 20.0183 15.0312 20.0674 15.0958 20.1013C15.1604 20.1352 15.2323 20.1529 15.3053 20.1529H19.0518C19.1307 20.1529 19.2083 20.1321 19.2766 20.0926C19.345 20.0532 19.4019 19.9965 19.4415 19.9282L25.9915 8.6168L35.5048 4.85033C35.9335 4.68071 36.3005 4.38472 36.5571 4.00165C36.8137 3.61857 36.9477 3.16653 36.9413 2.70552C36.935 2.24451 36.7886 1.79632 36.5216 1.42046C36.2545 1.0446 35.8795 0.758829 35.4463 0.60108L35.4436 0.603739ZM12.7903 2.09463L14.3118 1.16365L21.7503 3.89674L18.2604 5.61506L12.7903 2.09463ZM18.7884 19.2512H15.9556L19.4814 9.92682L25.5846 7.51691L18.7884 19.2512ZM35.171 4.01111L26.7164 7.35864L27.0116 6.84927C27.0585 6.76825 27.079 6.67465 27.0702 6.58147C27.0615 6.48828 27.024 6.40012 26.9629 6.32922C26.9018 6.25833 26.8201 6.20821 26.7292 6.18581C26.6384 6.16341 26.5428 6.16985 26.4557 6.20424L18.964 9.1621C18.9051 9.18593 18.8519 9.22194 18.8079 9.26778C18.7639 9.31363 18.7301 9.36826 18.7086 9.42808L18.1767 10.8179L11.306 13.4645C11.0816 13.547 10.8443 13.5889 10.6051 13.5882C9.55509 13.6123 8.53134 13.2583 7.72044 12.5907L1.32595 7.39189L2.40056 6.9663C3.063 6.70321 3.7802 6.60792 4.48835 6.6889C5.19651 6.76988 5.87368 7.02462 6.45963 7.43046L10.4682 10.2008C10.5342 10.2463 10.6111 10.2733 10.6911 10.2792C10.771 10.285 10.8511 10.2694 10.923 10.234L27.8628 1.89381C28.9792 1.32579 30.2004 0.993146 31.4507 0.916505C32.701 0.839865 33.9537 1.02087 35.1311 1.44827C35.3921 1.54394 35.6179 1.71659 35.7786 1.94341C35.9393 2.17022 36.0274 2.4405 36.0312 2.71846C36.0349 2.99642 35.9542 3.26896 35.7996 3.50003C35.6451 3.73109 35.424 3.90977 35.1657 4.01244L35.171 4.01111Z" fill="#1C3C6B"></path>
                  </svg>

                  <span class="product1">
                    Flight
                  </span>
                </span>

                <span class="search-type-tab"
                  (click)="searchFlightsMethod(3)">


                  <svg class="product-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;" viewBox="0 0 6.82666 8.533325000000001" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd"><defs><style type="text/css">

                    .fil0 {
                    fill: black
                  }
                  </style></defs><g><g><path class="fil0" d="M3.41336 1.09805c-1.27669,0 -2.3153,1.03861 -2.3153,2.31528 1.9685e-005,1.27667 1.0386,2.31528 2.31527,2.31528 1.27669,0 2.31528,-1.03861 2.31528,-2.31528 0,-1.27667 -1.03861,-2.31528 -2.31525,-2.31528zm0 4.76389c-1.35016,0 -2.44864,-1.09847 -2.44864,-2.44861 1.1811e-005,-1.35028 1.09847,-2.44861 2.44861,-2.44861 1.35028,-3.93701e-006 2.44861,1.09833 2.44861,2.44861 7.87402e-006,1.35014 -1.09833,2.44861 -2.44859,2.44861z" /><path class="fil0" d="M5.2828 4.95639c-0.0170945,0 -0.034185,-0.00652756 -0.0472402,-0.0194409l-3.34582 -3.34584c-0.0259685,-0.0261102 -0.0259843,-0.0683307 -1.1811e-005,-0.0943031 0.0261378,-0.0259724 0.0683346,-0.0259724 0.0943071,0l3.34586 3.34583c0.0259685,0.0259724 0.0259409,0.0681969 -2.75591e-005,0.0943071 -0.0130354,0.0129134 -0.0301457,0.0194409 -0.0470669,0.0194409zm-0.393063 0.392917c-0.016937,0 -0.0340433,-0.00652756 -0.0470984,-0.0194449l-3.34581 -3.34583c-0.0259685,-0.0259764 -0.0259961,-0.0681969 -2.3622e-005,-0.0943071 0.0261181,-0.0259764 0.0683307,-0.0259724 0.0943071,0l3.34584 3.34583c0.0259685,0.0259724 0.0259606,0.0681929 -7.87402e-006,0.0943031 -0.0130551,0.0129173 -0.0301417,0.0194449 -0.0472126,0.0194449z" /><path class="fil0" d="M3.41336 0.493189c-1.61016,0 -2.92017,1.31 -2.92017,2.92014 7.87402e-006,1.61014 1.31,2.92014 2.92014,2.92014 1.61015,0 2.92014,-1.31 2.92014,-2.92014 1.1811e-005,-1.61014 -1.31,-2.92014 -2.92011,-2.92014zm0 5.97361c-0.815563,0 -1.58239,-0.317638 -2.15919,-0.894303 -0.57665,-0.576807 -0.894307,-1.34361 -0.894307,-2.15917 0,-0.815693 0.317642,-1.58236 0.894307,-2.15917 0.576819,-0.576665 1.34361,-0.894307 2.15917,-0.894307 0.815717,0 1.5825,0.317642 2.15917,0.894307 0.576669,0.576807 0.894303,1.34347 0.894303,2.15917 2.3622e-005,0.815555 -0.317638,1.58236 -0.894303,2.15917 -0.576642,0.576665 -1.34347,0.894303 -2.15914,0.894303z" /><path class="fil0" d="M5.32973 4.35291c-0.0084685,0 -0.0170945,-0.00166535 -0.0251496,-0.00499606l-1.09888 -0.448335c-0.0341535,-0.0138898 -0.0504252,-0.0527795 -0.0365354,-0.0869449 0.0139134,-0.0340276 0.0527795,-0.0504173 0.0869449,-0.0365276l1.00697 0.410831 0 -0.367638 -1.49 -0.727224c-0.0233465,-0.011248 -0.0379449,-0.0351339 -0.0373858,-0.0611063l0.0171024 -0.910142c-0.000685039,-0.0226378 -0.0201575,-0.44861 -0.337937,-0.560413 -0.000968504,-0.000417323 -0.00152756,-0.000555118 -0.00152756,-0.000555118 2.75591e-005,-3.93701e-006 -0.000555118,0.000137795 -0.00152756,0.000555118 -0.319008,0.112217 -0.33722,0.537083 -0.337917,0.560276l0.00947244 0.501807c0.000688976,0.0368031 -0.0286378,0.0672205 -0.0654409,0.0679134 -0.0368071,0.000559055 -0.0672244,-0.0286102 -0.0679173,-0.0654134l-0.00942126 -0.503197c0,-0.000834646 -2.3622e-005,-0.00166535 -2.3622e-005,-0.00249606 0.000429134,-0.0219488 0.0141654,-0.539449 0.426945,-0.684724 0.0304213,-0.0106969 0.061248,-0.0106929 0.0916654,0 0.412787,0.145276 0.426669,0.66278 0.426945,0.684724 2.75591e-005,0.000826772 0,0.00166535 0,0.00249606l-0.016378 0.869169 1.48916 0.726803c0.022937,0.0111102 0.0375,0.0343071 0.0375,0.0598622l0 0.50861c0,0.0220827 -0.0111142,0.0429173 -0.0294449,0.0552795 -0.0112441,0.00749606 -0.0241693,0.0113858 -0.0372126,0.0113858zm-2.81681 1.04722c-0.021937,0 -0.0436181,-0.00652756 -0.0627874,-0.0193071 -0.0323386,-0.0213898 -0.0509685,-0.0561102 -0.0509685,-0.0949961l3.93701e-006 -0.163335c0,-0.0331969 0.0129134,-0.0629173 0.0365197,-0.0836102l0.554201 -0.488197 -0.016811 -0.794724 -1.45085 0.591949c-0.020563,0.00833071 -0.0440394,0.0059685 -0.062374,-0.00638976 -0.0184685,-0.0123622 -0.0295827,-0.0331969 -0.0295827,-0.0552795l1.9685e-005 -0.50861c0,-0.0255591 0.0145669,-0.048752 0.0374803,-0.0598622l1.26861 -0.619165c0.033063,-0.0161142 0.0730551,-0.0023622 0.0891654,0.0306969 0.0161142,0.0330512 0.00235827,0.0729134 -0.0306969,0.0891654l-1.23125 0.600831 0 0.367638 1.44891 -0.590972c0.0202795,-0.00833071 0.0433189,-0.00611024 0.0616457,0.00597638 0.0184764,0.0120827 0.0295866,0.0323583 0.0301417,0.0543031l0.0194606 0.9225c0.000405512,0.0197244 -0.00779528,0.0384724 -0.0225157,0.0515276l-0.568732 0.50111 0 0.126531 0.838469 -0.32139c0.028626,-0.0109764 0.0581772,-0.0108346 0.0855433,0.000275591l0.837799 0.321114 0 -0.126531 -0.568906 -0.50111c-0.014563,-0.0129173 -0.0229213,-0.0316654 -0.0225079,-0.051248l0.00738189 -0.410421c0.000562992,-0.0368031 0.0309528,-0.0667992 0.0677598,-0.0654134 0.0368031,0.000555118 0.0661102,0.0309724 0.0655551,0.0677795l-0.00694094 0.379579 0.554315 0.488339c0.00112598,0.000830709 0.0020748,0.00180315 0.00304331,0.00277559 0.0219567,0.0219449 0.0336102,0.0498622 0.0336102,0.0808346l0 0.163335c0,0.0388858 -0.0186102,0.0736063 -0.0511102,0.0949961 -0.0311063,0.0206929 -0.0695866,0.0247244 -0.105417,0.0109724l-0.857752 -0.328748 -0.856969 0.328472c-0.0141575,0.00569291 -0.0288898,0.00861024 -0.0434685,0.00861024z" /></g></g></svg>
                  <span class="product" style="font-size: 14px;" >
                    Offline Booking
                  </span>
                </span>

                <span class="search-type-tab"
                  [class.active]="selectedMainDiv === 2"  (click)="searchFlightsMethod(2)">

                  <svg class="product-icon" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 100 125" x="0px" y="0px"><path d="M94.26758,48.23242a2.4991,2.4991,0,0,1,0,3.53516L76.87988,69.15625a2.49973,2.49973,0,0,1-3.53515-3.53516L86.465,52.5H29.72363a2.5,2.5,0,0,1,0-5H86.465L73.34473,34.37891a2.49973,2.49973,0,1,1,3.53515-3.53516ZM58,27.66016a2.49981,2.49981,0,0,0,2.5-2.5V12.12207A7.1306,7.1306,0,0,0,53.37793,5H12.12207A7.1306,7.1306,0,0,0,5,12.12207V87.87793A7.1306,7.1306,0,0,0,12.12207,95H53.37793A7.1306,7.1306,0,0,0,60.5,87.87793V74.83984a2.5,2.5,0,1,0-5,0V87.87793A2.12472,2.12472,0,0,1,53.37793,90H12.12207A2.12472,2.12472,0,0,1,10,87.87793V12.12207A2.12472,2.12472,0,0,1,12.12207,10H53.37793A2.12472,2.12472,0,0,1,55.5,12.12207V25.16016A2.49981,2.49981,0,0,0,58,27.66016Z" /></svg>
                  <span class="product">
                    Import PNR
                  </span>
                </span>

                <span class="search-type-tab"
                  (click)="GroupTicketForUser()" >

                  <svg class="product-icon" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 16.933333 21.1666675" version="1.1" x="0px" y="0px"><g><path style="color:#000000;" d="m 12.875,6.2460937 c -0.100893,0.00224 -0.202321,0.015911 -0.302734,0.041016 l -5.2519535,1.3125 C 7.244505,7.6185612 7.1664264,7.5980673 7.1113281,7.5429687 L 6.5957031,7.0273437 C 6.4311793,6.8628201 6.17867,6.8217988 5.9707031,6.9257812 L 5.7617187,7.03125 C 5.5322567,7.1459809 5.4424909,7.4383437 5.5683594,7.6621094 l 0.8046875,1.4296875 c 0.2776605,0.4936186 0.8630396,0.730079 1.40625,0.5703125 L 9.84375,9.0546875 9.828125,11.509766 c -0.00138,0.18032 0.174056,0.309174 0.345703,0.253906 l 0.957031,-0.310547 c 0.09431,-0.03051 0.163662,-0.111166 0.179688,-0.208984 L 11.75,8.4941406 13.552734,7.9648437 c 0.506218,-0.1172971 0.747941,-0.7230704 0.460938,-1.15625 -0.0032,-0.004 -0.0064,-0.00791 -0.0098,-0.011719 C 13.73465,6.4378656 13.312289,6.236411 12.875,6.2460937 Z m 0.01172,0.5292969 c 0.26405,-0.00585 0.517107,0.1175054 0.683594,0.3320313 0.08576,0.1382193 0.02369,0.3046285 -0.136719,0.3417968 -0.0046,0.00118 -0.0091,0.00248 -0.01367,0.00391 L 11.441409,8.03516 c -0.09791,0.028332 -0.170842,0.1103813 -0.1875,0.2109375 L 10.814453,11 10.359375,11.146484 10.375,8.703125 C 10.37646,8.5253164 10.20563,8.3967033 10.035156,8.4472656 L 7.6308594,9.1542969 C 7.3211508,9.2453869 6.9921882,9.1132825 6.8339844,8.8320313 L 6.0664062,7.46875 6.2070312,7.4003906 c 0.00606,-0.00303 0.010948,-0.00272 0.015625,0.00195 l 0.5136719,0.513675 C 6.922393,8.1020816 7.1941534,8.1770474 7.4492187,8.1132813 L 12.699219,6.8007812 c 0.06207,-0.015517 0.125493,-0.024013 0.1875,-0.025391 z" fill="#000000" stroke-linejoin="round" /><path style="color:#000000;" d="M 8.2148438,5.1699219 7.3652344,5.453125 C 7.162828,5.520991 7.1199729,5.7882716 7.2910156,5.9160156 L 9.5097656,7.5683594 9.8261719,7.1445312 8.0136719,5.7949219 8.2734375,5.7089844 10.958984,7.1640625 11.210938,6.6992187 8.4238281,5.1894531 C 8.3598379,5.1544111 8.284219,5.1473439 8.2148438,5.1699219 Z" fill="#000000" stroke-linejoin="round" /><path style="color:#000000;" d="M 3.96875,7.6738281 C 3.8233357,7.6743283 3.7055782,7.7920857 3.7050781,7.9375 V 8.9960938 C 3.7055783,9.1415081 3.8233357,9.2592654 3.96875,9.2597656 4.1141642,9.2592654 4.2319217,9.1415081 4.2324219,8.9960938 V 7.9375 C 4.2319217,7.7920857 4.1141643,7.6743283 3.96875,7.6738281 Z" fill="#000000" stroke-linecap="round" /><path style="color:#000000;" d="M 3.96875,9.7890625 C 3.8225731,9.789565 3.7045015,9.9085114 3.7050781,10.054688 v 1.058593 c 5.001e-4,0.145414 0.1182576,0.263172 0.2636719,0.263672 0.1454143,-5e-4 0.2631718,-0.118258 0.2636719,-0.263672 V 10.054688 C 4.2329985,9.9085114 4.1149269,9.789565 3.96875,9.7890625 Z" fill="#000000" stroke-linecap="round" /><path style="color:#000000;" d="m 3.96875,11.90625 c -0.1454143,5e-4 -0.2631718,0.118258 -0.2636719,0.263672 v 1.058594 l 0.5273438,0 V 12.169922 C 4.2319218,12.024508 4.1141643,11.90675 3.96875,11.90625 Z" fill="#000000" stroke-linecap="round" /><path style="color:#000000;" d="M 3.96875,5.5566406 C 3.8233357,5.5571408 3.7055783,5.6748982 3.7050781,5.8203125 V 6.8789062 C 3.7045018,7.0250826 3.8225733,7.1440287 3.96875,7.1445312 4.1149267,7.1440287 4.2329982,7.0250826 4.2324219,6.8789062 V 5.8203125 C 4.2319217,5.6748982 4.1141643,5.5571408 3.96875,5.5566406 Z" fill="#000000" stroke-linecap="round" /><path style="color:#000000;" d="M 3.7050781,3.7050781 V 4.7617187 C 3.7045018,4.9078951 3.8225733,5.0268412 3.96875,5.0273437 4.1149267,5.0268412 4.2329982,4.9078951 4.2324219,4.7617187 V 3.7050781 c 0,0 -0.5282552,-9.114e-4 -0.5273438,0 z" fill="#000000" stroke-linecap="round" /><path style="color:#000000;" d="m 2.3808594,3.4394531 c -1.1658675,-3e-7 -2.11718753,0.9513196 -2.11718752,2.1171875 v 0.7929688 c 0,0.4398932 0.34632313,0.7450203 0.69921875,0.8671875 0.51719457,0.1790449 0.88867187,0.6685184 0.88867187,1.25 0,0.5814984 -0.3714539,1.0709681 -0.88867187,1.25 C 0.60999828,9.8389474 0.26367188,10.144108 0.26367188,10.583984 v 0.793099 c -6.267e-5,1.166593 0.95061062,2.119173 2.11718752,2.123047 H 14.552734 c 1.166577,-0.0039 2.115297,-0.956454 2.115235,-2.123047 v -0.793099 c 0,-0.439876 -0.344375,-0.7450363 -0.697266,-0.8671871 -0.517218,-0.179032 -0.888672,-0.6685015 -0.888672,-1.25 0,-0.5814817 0.371477,-1.070955 0.888672,-1.25 0.352895,-0.1221672 0.697266,-0.4272941 0.697266,-0.8671875 V 5.5566406 c 0,-1.1658679 -0.949367,-2.1171878 -2.115235,-2.1171875 z m 0,0.5292969 H 14.552734 c 0.879885,-3e-7 1.585938,0.7080054 1.585938,1.5878906 v 0.7929688 c 0,0.1446074 -0.142901,0.2990088 -0.339844,0.3671875 -0.726011,0.2513338 -1.246094,0.9418861 -1.246094,1.75 0,0.8081373 0.52005,1.4986843 1.246094,1.7500001 0.196894,0.06815 0.339844,0.222564 0.339844,0.367187 v 0.793099 c 4.7e-5,0.880563 -0.705627,1.58978 -1.585938,1.59375 H 2.3828125 2.3808594 c -0.8803107,-0.004 -1.58793795,-0.713187 -1.58789065,-1.59375 v -0.793099 c 0,-0.144623 0.14490255,-0.299034 0.34179685,-0.367187 0.7260436,-0.2513158 1.2460938,-0.9418627 1.2460938,-1.7500001 0,-0.808114 -0.5200834,-1.4986662 -1.2460938,-1.75 C 0.93782239,6.6486181 0.79296875,6.4942169 0.79296875,6.3496094 V 5.5566406 c 0,-0.8798852 0.70800615,-1.5878909 1.58789065,-1.5878906 z" fill="#000000" stroke-linejoin="round" /></g></svg>
                  <!--<i class="fas fa-ticket product-icon"></i>-->
                  <span class="product">
                    Group Ticket
                  </span>
                </span>


              </div>

              @if (selectedMainDiv === 1) {
                <div id="oneWayDiv ant-row">
                  <div class="ant-col ant-col-24">
                    <div class="ant-row ant-row-middle">
                      <div class="flight-type-wrapper menu">
                        <label class="radio" (click)="showtoggleflighttypeDiv(1)" id="onetriptypeclick">
                          <input type="radio" [checked]="selectedDiv === 1" name="flight-type" value="One Way">
                          <span class="radio-btn"></span>
                          <span class="flight-type-text">One Way</span>
                        </label>
                        <label class="radio" (click)="showtoggleflighttypeDiv(2)" id="roundtriptypeclick1">
                          <input type="radio" [checked]="selectedDiv === 2" name="flight-type" value="Round Trip">
                          <span class="radio-btn"></span>
                          <span class="flight-type-text">Round Trip</span>
                        </label>
                        <label class="radio" (click)="showtoggleflighttypeDiv(3)" id="multitriptypeclick">
                          <input type="radio" [checked]="selectedDiv === 3" name="flight-type" value="Multi City">
                          <span class="radio-btn"></span>
                          <span class="flight-type-text">Multi City</span>
                        </label>
                      </div>
                      <div class="customn_column addflightbtn menu"
                        id="addflightbtn">
                        <div class="">
                          <div class="justify-content-between">
                            @if (selectedDiv === 3) {
                              <div class="grid">
                                <button class="btn btn-md btndesigntriptypemodify1"
                                  style="color: white"
                                  (click)="AddNewFlight()" type="button">
                                  @if (!idAssigned) {
                                    <i class="fa fa-plus-circle">
                                      Add Flight
                                    </i>
                                  }
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Round trip Div-->
                  <div>
                    <div class="">
                      @for (flights of searchObj.flightLocationInfo; track flights; let f = $index) {
                        <div class="row  m-0" style="position: relative;">
                          <!--<div *ngIf="selectedDiv === 3">
                          <div class="col-12 modifySearchFligthHeading">Flight {{ f + 1 }}</div>
                        </div>-->
                        <!-- From Airport Section -->
                        <div [ngClass]="selectedDiv === 3? 'col-xl-4 col-md-4 col-sm-12 col-12 d-flex flex-column':'col-xl-3 col-md-6 col-sm-12 col-12 mb-4 d-flex flex-column'" style="position:relative;">
                          <i class="fas fa-location-dot modifySearchAirportDisplyUpperIcon"></i>
                          <span [ngClass]="submitFlightSearch && !flights.fromAirport ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">From</span>
                          @if (flights.fromAirport) {
                            <div>
                              <div [ngClass]="selectedDiv === 3? 'modifySearchAirportDisplyDivMulti':'modifySearchAirportDisplyDiv'" (click)="ClickSearchFromAirport(f)">
                                <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMulti':'modifySearchAirportDisplyUpper'">
                                  <span>{{flights.fromAirport.split('-')[1]}}</span>
                                </div>
                                <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMultiLower':'modifySearchAirportDisplyLower'">
                                  {{flights.fromAirport.split('-')[2]}} ({{flights.fromAirport.split('-')[0]}})
                                </div>
                              </div>
                            </div>
                          }
                          @if (!flights.fromAirport) {
                            <div>
                              <p-autoComplete #focusable1 [showEmptyMessage]="true" [(ngModel)]="flights.fromAirport"
                                [suggestions]="filteredAirportsOW" (completeMethod)="filterAirportsOW($event)"
                                [forceSelection]="true" [minLength]="2" name="fromAirport{{f}}"
                                [required]="true"
                                (blur)="validateAirports()"
                                (onSelect)="SearchFlightFromCity(flights.fromAirport, f)"
                                [ngClass]="selectedDiv === 3? ' modifySearchAutoCompMulti ' : 'modifySearchAutoComp'">
                                <ng-template let-filteredAirports pTemplate="item">
                                  <div class="modifySearchAirports">
                                    <div class="modifySearchAirportsInner">
                                      <span class="modifySearchCityName">{{filteredAirports.split('-')[1]}}</span>
                                      <span class="modifySearchAirportName">{{filteredAirports.split('-')[2]}}</span>
                                    </div>
                                    <div class="modifySearchAirportsIataDiv">
                                      <span class="modifySearchAirportsIATA">{{filteredAirports.split('-')[0]}}</span>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-autoComplete>
                            </div>
                          }
                          @if (submitFlightSearch && !flights.fromAirport) {
                            <span class="error_class">
                              **Flying From Required!
                            </span>
                          }
                        </div>
                        <!-- Double Arrow -->
                        <div [class]="selectedDiv === 3 ? 'modifySearchDoubleArrowMulticity' : 'modifySearchDoubleArrow'">
                          <i class="fas fa-exchange-alt" (click)="InvertSearchFromTo(f)"></i>
                        </div>
                        <!-- To Airport Section -->
                        <div [ngClass]="selectedDiv === 3?'col-xl-4 col-md-4 col-sm-12 col-12 d-flex flex-column':'col-xl-3 col-md-6 col-sm-12 col-12 mb-4 d-flex flex-column'" style="position:relative;">
                          <i class="fas fa-location-dot modifySearchAirportDisplyUpperIcon"></i>
                        <span [ngClass]="submitFlightSearch && !flights.toAirport
  ? 'labelofmodifyserachinputs'
  : submitFlightSearch && flights.toAirport && flights.fromAirport && flights.toAirport === flights.fromAirport
  ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                            To
                          </span>
                          @if (flights.toAirport) {
                            <div>
                              <div [ngClass]="selectedDiv === 3? 'modifySearchAirportDisplyDivMulti':'modifySearchAirportDisplyDiv'" (click)="ClickSearchToAirport(f)">
                                <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMulti':'modifySearchAirportDisplyUpper'">
                                  <span>{{flights.toAirport.split('-')[1]}}</span>
                                </div>
                                <div [ngClass]="selectedDiv === 3 ?'modifySearchAirportDisplyMultiLower':'modifySearchAirportDisplyLower'">
                                  {{flights.toAirport.split('-')[2]}} ({{flights.toAirport.split('-')[0]}})
                                </div>
                              </div>
                            </div>
                          }
                          @if (!flights.toAirport) {
                            <div>
                              <p-autoComplete #focusable [showEmptyMessage]="true" [suggestions]="filteredAirportsOW"
                                (completeMethod)="filterAirportsOW($event)" [forceSelection]="true" [multiple]="false"
                                [minLength]="2" name="toAirport{{f}}" [required]="true"
                                [(ngModel)]="flights.toAirport"
                                (blur)="validateAirports()"
                                (onSelect)="SearchFlightToCity(flights.toAirport, f)"
                                [ngClass]="selectedDiv === 3 ? ' modifySearchAutoCompMulti ' : 'modifySearchAutoComp'">
                                <ng-template let-filteredAirports pTemplate="item">
                                  <div class="modifySearchAirports">
                                    <div class="modifySearchAirportsInner">
                                      <span class="modifySearchCityName">{{filteredAirports.split('-')[1]}}</span>
                                      <span class="modifySearchAirportName">{{filteredAirports.split('-')[2]}}</span>
                                    </div>
                                    <div class="modifySearchAirportsIataDiv">
                                      <span class="modifySearchAirportsIATA">{{filteredAirports.split('-')[0]}}</span>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-autoComplete>
                            </div>
                          }
                          @if (submitFlightSearch && !flights.toAirport ) {
                            <span class="error_class">
                              **Flying To Required!
                            </span>
                          }
                          @if (submitFlightSearch && flights.toAirport !=''&& flights.fromAirport !='' && flights.toAirport.split('-')[0] == flights.fromAirport.split('-')[0]) {
                            <span class="error_class">
                              **From & To Should not Same!
                            </span>
                          }
                        </div>
                        <div [ngClass]="selectedDiv != 3 ? 'col-xl-2 col-md-4 col-sm-12 col-12 mb-lg-4 mb-4 d-flex flex-column' : 'col-xl-3 col-md-3 col-sm-12 col-12 mb-lg-4 mb-4 d-flex flex-column'" style="position:relative;">
                          <span [ngClass]="submitFlightSearch && !flights.departureDateFront ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                            Departure Date
                          </span>
                          <i class="fas fa-calendar-alt modifySearchCalenderIcon"></i>
                          <p-datepicker [(ngModel)]="flights.departureDateFront" #departureDateId [minDate]="currentDateDepartureList[f]" (ngModelChange)="SetReturnMinDate(flights.departureDateFront!)"
                            name="departureDate{{f}}" [readonlyInput]="true"
                            [ngClass]="submitFlightSearch && !flights.departureDateFront ? 'modifySearchCalender modifySearchDepartureCalender' : 'modifySearchCalender modifySearchDepartureCalender'"
                            [numberOfMonths]="mobileDatepicker.monthsToShow"
                            [touchUI]="mobileDatepicker.isMobile"
                            [appendTo]="'body'"
                            (onShow)="mobileDatepicker.protectDatepicker(departureDateId)"
                            (onClose)="mobileDatepicker.ensureScrollUnlocked()"
                            dateFormat="dd M yy"
                            required>
                          </p-datepicker>
                          @if (!flights.departureDateFront && submitFlightSearch) {
                            <div>
                              <div style="width: 100%; height: 20px; display: flex; justify-content: start; align-items: center;">
                                <span class="error_class">** Departure Date Required!</span>
                              </div>
                            </div>
                          }
                        </div>
                        @if (selectedDiv === 1 || selectedDiv === 2) {
                          <div class="col-xl-2 col-md-4 col-sm-12 col-12 d-flex flex-column daysFieldsm" style="position:relative;">
                            <span [ngClass]="submitFlightSearch && !searchObj.days ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                              Days
                            </span>
                            <input [(ngModel)]="searchObj.days" (blur)="addDaysReturn()"
                              [disabled]="selectedDiv === 1" [ngClass]="(submitFlightSearch && !searchObj.days && selectedDiv === 2) ? 'modifySearchDays' : 'modifySearchDays'"
                              name="datereturndays{{f}}" type="number" />
                            </div>
                          }
                          @if (selectedDiv === 1 || selectedDiv === 2) {
                            <div class="col-xl-2 col-md-4 col-sm-12 col-12 mb-lg-4 mb-4 d-flex flex-column" style="position:relative;">
                              <span [ngClass]="submitFlightSearch && !searchObj.returnDateFront ? 'labelofmodifyserachinputs' : 'labelofmodifyserachinputs'">
                                Return Date
                              </span>
                              <i class="fas fa-calendar-alt modifySearchCalenderIcon"></i>
                              <p-datepicker [(ngModel)]="searchObj.returnDateFront" #returnDateId [minDate]="currentDateReturn"
                                name="returnDate{{f}}" [readonlyInput]="true"
                                [disabled]="selectedDiv === 1"
                                [ngClass]="(submitFlightSearch && !searchObj.returnDateFront && selectedDiv === 2) ? 'modifySearchCalender modifySearchReturnCalender': 'modifySearchCalender modifySearchReturnCalender'"
                                [numberOfMonths]="mobileDatepicker.monthsToShow"
                                [touchUI]="mobileDatepicker.isMobile"
                                [appendTo]="'body'"
                                (onShow)="mobileDatepicker.protectDatepicker(returnDateId)"
                                (onClose)="mobileDatepicker.ensureScrollUnlocked()"
                                (ngModelChange)="returndatechange()" dateFormat="dd M yy" required>
                              </p-datepicker>
                              @if (!searchObj.returnDateFront && submitFlightSearch && selectedDiv === 2) {
                                <div>
                                  <div style="width: 100%; height: 20px; display: flex; justify-content: start; align-items: center;">
                                    <span class="error_class">** Return Date Required!</span>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          @if (selectedDiv === 3 && f > 1) {
                            <div class="removeBtn col-xl-1 col-md-1  d-flex flex-column">
                              <a class="add_flight"
                                id="add_flight"
                                (click)="RemoveFlight(f)">
                                <i style="font-size: 1.2rem"
                                  class="uil uil-minus">
                                </i>
                              </a>
                            </div>
                          }
                        </div>
                      }
                      <div class="row sectionTwo">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-2 SectionTwoInner">
                          <div class="form-group">
                            <div class="p-float-label"
                              style="width: 100% !important">
                              <p-select class="modifyradiusdays"
                                [options]="adultList"
                                optionLabel="adultItem"
                                optionValue="adultItem"
                                multiple="true"
                                [(ngModel)]="searchObj.adult"
                                name="adult"
                                (onChange)="changeAdult()"
                                inputId="float-labels">
                              </p-select>
                              <label for="float-labels">Adult</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-2 SectionTwoInner"
                          style="position:relative;">
                          <span class="labelofserachinputs">
                            Child
                          </span>
                          <!--<i class="fas fa-person-icon modifySearchCalenderIcon"></i>-->
                          <p-select #dropdown class="modifySearch_dropPassenger" [options]="passengerSelectionList" [placeholder]="selectedChild" [filter]="false"
                            [showClear]="false">
                            <ng-template let-selectedItem pTemplate="selectedItem">
                              <span>{{ selectedChild }}</span>
                            </ng-template>
                            <ng-template let-item pTemplate="item">
                              <div class="dropdownPassengerItem">
                                <div class="dropdownPassengerItemLabelDiv">
                                  <span class="dropdownPassengerItemLabel">{{ item.label }}</span>
                                  <span class="dropdownPassengerItemLabelText">{{ item.labelText }}</span>
                                </div>
                                <div class="dropdownPassengerItemControls">
                                  <i class="fas fa-minus passengerItemControlsButton" (click)="DecrementPax(item); $event.stopPropagation()"></i>
                                  <span class="passengerItemControlsValue">{{ item.value }}</span>
                                  <i class="fas fa-plus passengerItemControlsButton" (click)="IncrementPax(item); $event.stopPropagation()"></i>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template pTemplate="footer">
                              <!--<div class="passengerItemAgesHeading text-center text-decoration-underline">
                              Total 9 Passengers are Allowed
                            </div>-->
                            @if (searchObj.childAges.length > 0) {
                              <div>
                                <div class="passengerItemAgesHeading">Child Ages</div>
                                <div class="passengerItemAgesMain" (click)=" $event.stopPropagation()">
                                  <div class="passengerItemAgesDiv">
                                    @for (chd of searchObj.childAges; track chd; let c = $index) {
                                      <div class="passengerItemAges">
                                        <span class="passengerItemAgesLabel">Child {{c+1}}'s Age</span>
                                        <p-select class="modifySearch_dropAges" name="childAges{{c}}" [options]="childAgeList"
                                          [filter]="false" [showClear]="false" optionLabel="childAgeItem" optionValue="childAgeItem"
                                          [(ngModel)]="searchObj.childAges[c]">
                                        </p-select>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="dropdownPassengerItemFooter">
                              <button type="button" class="btnsmalscreen" (click)="ClosePaxDropdown()">Done</button>
                            </div>
                          </ng-template>
                        </p-select>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-2 SectionTwoInner"
                        style="position:relative;">
                        <span class="labelofserachinputs">
                          Infant
                        </span>
                        <p-select #dropdown class="modifySearch_dropPassenger" [options]="passengerSelectionListInfant" [placeholder]="selectedInfant" [filter]="false"
                          [showClear]="false">
                          <ng-template let-selectedItem pTemplate="selectedItem">
                            <span>{{ selectedInfant }}</span>
                          </ng-template>
                          <ng-template let-item pTemplate="item">
                            <div class="dropdownPassengerItem">
                              <div class="dropdownPassengerItemLabelDiv">
                                <span class="dropdownPassengerItemLabel">{{ item.labelInf }}</span>
                                <span class="dropdownPassengerItemLabelText">{{ item.labelTextInf }}</span>
                              </div>
                              <div class="dropdownPassengerItemControls">
                                <i class="fas fa-minus passengerItemControlsButton" (click)="DecrementPaxInf(item); $event.stopPropagation()"></i>
                                <span class="passengerItemControlsValue">{{ item.valueInf }}</span>
                                <i class="fas fa-plus passengerItemControlsButton" (click)="IncrementPaxInf(item); $event.stopPropagation()"></i>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="footer">
                            <!--<div class="passengerItemAgesHeading text-center text-decoration-underline">
                            Total 9 Passengers are Allowed
                          </div>-->
                          @if (searchObj.infantAges.length > 0) {
                            <div>
                              <div class="passengerItemAgesHeading">Infant Ages</div>
                              <div class="passengerItemAgesMain" (click)=" $event.stopPropagation()">
                                <div class="passengerItemAgesDiv">
                                  @for (chd of searchObj.infantAges; track chd; let c = $index) {
                                    <div class="passengerItemAges">
                                      <span class="passengerItemAgesLabel">Infant {{c+1}}'s Age</span>
                                      <p-select class="modifySearch_dropAges" name="infantAges{{c}}" [options]="infantAgeList"
                                        [filter]="false" [showClear]="false" optionLabel="infantAgeItem" optionValue="infantAgeItem"
                                        [(ngModel)]="searchObj.infantAges[c]">
                                      </p-select>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          <div class="dropdownPassengerItemFooter">
                            <button type="button" class="btnsmalscreen" (click)="ClosePaxDropdown()">Done</button>
                          </div>
                        </ng-template>
                      </p-select>
                    </div>
                    @if (selectedDiv ===1 || selectedDiv === 3) {
                      <div class="col-12 col-sm-6 col-md-6 col-lg-3 SectionTwoInner1">
                        <div class="form-group">
                          <div class="p-float-label"
                            style="width: 100% !important">
                            <p-select class="modifyradiusdays"
                              [options]="cabinClassList"
                              multiple="true"
                              name="cabinClass"
                              optionLabel="cabinItem"
                              optionValue="cabinItem"
                              [(ngModel)]="searchObj.cabinClass"
                              inputId="float-labels">
                            </p-select>
                            <label for="float-labels">Travel Class</label>
                          </div>
                        </div>
                      </div>
                    }
                    @if (selectedDiv === 2) {
                      <div class="d-flex col-12 col-sm-12 col-md-6 col-lg-4 SectionTwoInner1 roundTripTravelClassContainer">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                          <div class="form-group">
                            <div class="p-float-label"
                              style="width: 100% !important">
                              <p-select class="modifyradiusdays"
                                [options]="cabinClassList"
                                multiple="true"
                                name="cabinClass"
                                optionLabel="cabinItem"
                                optionValue="cabinItem"
                                [(ngModel)]="searchObj.cabinClass"
                                inputId="float-labels">
                              </p-select>
                              <label for="float-labels">Departure Travel Class</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                          <div class="form-group">
                            <div class="p-float-label"
                              style="width: 100% !important">
                              <p-select class="modifyradiusdays"
                                [options]="cabinClassList"
                                multiple="true"
                                name="cabinClassReturnTrip"
                                optionLabel="cabinItem"
                                optionValue="cabinItem"
                                [(ngModel)]="searchObj.cabinClassReturnTrip"
                                inputId="float-labels">
                              </p-select>
                              <label for="float-labels">Return Travel Class</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <div [ngClass]="selectedDiv === 2 ? 'col-12 col-sm-6 col-md-4 col-lg-2 SectionTwoInner1': 'col-12 col-sm-6 col-md-6 col-lg-3 SectionTwoInner1'">
                      <div class="form-group">
                        <div class="p-float-label"
                          style="width: 100% !important">
                          <p-select class="modifyradiusdays"
                            [options]="fareTypeList"
                            multiple="true"
                            optionLabel="fareItem"
                            optionValue="fareItem"
                            [(ngModel)]="searchObj.fareType"
                            name="fareType"
                            inputId="float-labels">
                          </p-select>
                          <label for="float-labels">Fare Type</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row m-0 advance-search-container" style="display:flex; flex-direction:column;">
                  <!-- Button to toggle visibility -->
                  <div class="col-12 col-xl-12 col-md-12 col-sm-12 advance-search-toggle-col" style="display: flex; justify-content: flex-end; width: 100%;">
                    <a (click)="toggleSectionVisibility()" style="text-decoration: underline; color:#ffaa00; cursor:pointer;">
                      {{ isSectionVisible ? 'Hide Search' : 'Advance Search' }}
                    </a>
                  </div>
                  <!-- The section to be hidden/shown with flex layout and animation -->
                  <div [@sectionAnimation]="isSectionVisible ? 'visible' : 'hidden'" class="row m-0 sectionThree">
                    <div class="col-12 col-sm-6 col-md-3 col-xl-2 SectionTwoInner1">
                      <div class="advance-checkbox-wrapper">
                        <input type="checkbox" name="cbNonstop" id="cbNonstop" [(ngModel)]="searchObj.nonStopFlight" />
                        <label class="inner_lable" for="cbNonstop">Non-stop flights</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3 col-xl-2 SectionTwoInner1">
                      <div class="advance-checkbox-wrapper">
                        <input type="checkbox" name="cbNearAirport" id="cbNearAirport" [(ngModel)]="searchObj.nearByAirport" />
                        <label class="inner_lable" for="cbNearAirport">Nearby Airports</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3 col-xl-2 SectionTwoInner1">
                      <div class="advance-checkbox-wrapper">
                        <input type="checkbox" name="lowCostAirline" id="lowCostAirline" [(ngModel)]="searchObj.lowCostAirline" />
                        <label class="inner_lable" for="lowCostAirline">Low Cost Airlines</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3 col-xl-2 SectionTwoInner1">
                      <div class="advance-checkbox-wrapper">
                        <input type="checkbox" name="gdsAirline" id="gdsAirline" [(ngModel)]="searchObj.gdsAirline" />
                        <label class="inner_lable" for="gdsAirline">GDS Airlines</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-xl-4 advance-airline-col">
                      <div class="form-group advance-airline-group">
                        <div class="p-float-label advance-airline-float-label" style="width: 100% !important;">
                          <p-multiSelect [options]="airlineList$"
                            [(ngModel)]="preferedAirlines"
                            [style]="{ width: '100%' }"
                            [filter]="true"
                            placeholder="From"
                            optionLabel="airlineName"
                            optionValue="airlineCombineCode"
                            [ngModelOptions]="{standalone: true}"
                            [panelStyle]="{ 'width': '1em' }"
                            panelHideOnClickOutside="false"
                            [selectionLimit]="3">
                          </p-multiSelect>
                          <label for="float-labels">Select Airline</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row customn_row searchHistorymain">
                  <div class="col-lg-3 col-md-5 col-sm-5 col-12 searchSection">
                    <button class="button btnsmalscreen"  (click)="showDialog()" type="button">
                      <i class="fas fa-history-icon" style="font-size: 14px"></i>&nbsp; History
                    </button>
                    <p-dialog header="Search History" [(visible)]="dialogVisible" [modal]="true" [style]="{ width: '50vw' }" [breakpoints]="{ '767px': '90vw' }" styleClass="search-history-dialog" class="search-history-dialog">
                      <div class="search-history-container">
                        <h3>Recent Flights</h3>
                        <div class="flight-card-row">
                          @for (hist of searchHistoryList; track hist; let k = $index) {
                            <div class="flight-card col-md-6 col-lg-4">
                              <div id="link{{ k }}"
                                (mouseenter)="toggleWithAnimationOptions(k)"
                                (mouseleave)="toggleWithAnimationOptions(k)"
                                (click)="searchWithHistory(k)">
                                <div class="ribbonSearchHist col-md-12">
                                  <span style="color:white;">{{ hist.tripType }}</span>
                                </div>
                                <div class="row">
                                  <div class="col-sm-6 col-md-12 col-lg-6">{{ hist.fromCity }} - {{ hist.toCity }}</div>
                                  <div class="col-sm-6 col-md-12 col-lg-6">{{ hist.departureDate }}</div>
                                </div>
                              </div>
                              <dx-popover target="#link{{ k }}" position="right" [width]="300" [(visible)]="popoverArray[k]"
                                [wrapperAttr]="{ class: 'history-card-popover-wrapper' }" class="history-card-popover">
                                <dxo-animation>
                                  <dxo-show type="pop" [from]="{ scale: 0 }" [to]="{ scale: 1 }"></dxo-show>
                                  <dxo-hide type="fade" [from]="1" [to]="0"></dxo-hide>
                                </dxo-animation>
                                <div *dxTemplate="let data = model; of: 'content'" class="history-popover-content">
                                  <p>
                                    <strong>Airport (from):</strong> {{ hist.fromAirport }}
                                  </p>
                                  <p>
                                    <strong>Airport (to):</strong> {{ hist.toAirport }}
                                  </p>
                                  <p>
                                    <strong>Departure Date:</strong> {{ hist.departureDate }}
                                  </p>
                                  <p>
                                    <strong>Return Date:</strong> {{ hist.returnDate }}
                                  </p>
                                  <p>
                                    <strong>Trip Type:</strong>
                                    @if (hist.tripType == 'Oneway') {
                                      <span>OW</span>
                                    }
                                    @if (hist.tripType == 'Roundway') {
                                      <span>RT</span>
                                    }
                                    @if (hist.tripType == 'Multi City') {
                                      <span>MC</span>
                                    }
                                  </p>
                                  <p>
                                    <strong>Travel Class:</strong> {{ hist.travelClass }}
                                  </p>
                                  <p>
                                    <strong>Fare Type:</strong> {{ hist.fareType }}
                                  </p>
                                  <p>
                                    <strong>Passengers:</strong><br />
                                    Adult: {{ hist.adults }}, Child: {{ hist.children }}, Infant: {{ hist.infants }}
                                  </p>
                                </div>
                              </dx-popover>
                            </div>
                          }
                        </div>
                      </div>
                      <p-footer>
                        <p-button label="Close" (onClick)="dialogVisible = false"></p-button>
                      </p-footer>
                    </p-dialog>
                  </div>
                  <div class="col-lg-6 col-md-2 col-sm-2 pt-2 d-none d-md-block"></div>
                  <div class="col-lg-3 col-md-5 col-sm-5 col-12 searchbtnSection">
                    <button class="button btnsmalscreen"
                      type="submit">
                      <i class="fas fa-search" style="font-size: 14px"></i>&nbsp; Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- 2nd Tab -->
          @if (selectedMainDiv === 3) {
            <div id="offlineBooking"
              style="width: 100%">
              <div style="padding:10px;display:flex;justify-content:center;align-items:center">
                <div style="font-size:20px;color:#ffaa00;font-weight:bold;letter-spacing:3px">
                  Offline Request
                </div>
              </div>
              <div class="offlineBookingbtns">
                <ul class="nav nav-tabs">
                  @if (tktPnrRight.offlinebooking) {
                    <li class="nav-item">
                      <button class="nav-link" id="tours-tab" type="button" (click)="offlineClick(1)"><i class="fas fa-plane"></i>Booking</button>
                    </li>
                  }
                  @if (tktPnrRight.offlineIssue) {
                    <li class="nav-item" >
                      <button class="nav-link" id="flights-tab" type="button" (click)="offlineClick(2)"><i class="fas fa-ticket"></i>Ticket</button>
                    </li>
                  }
                  @if (tktPnrRight.offlinerefund) {
                    <li class="nav-item" >
                      <button class="nav-link" id="hotels-tab" type="button" aria-controls="hotels" (click)="offlineClick(4)"><i class="fas fa-money-bill"></i>Refund</button>
                    </li>
                  }
                  @if (tktPnrRight.offlineVoid) {
                    <li class="nav-item" >
                      <button class="nav-link" id="visa-tab" type="button" (click)="offlineClick(5)"><i class="fas fa-passport"></i> Void</button>
                    </li>
                  }
                  @if (tktPnrRight.offlinereissue) {
                    <li class="nav-item" >
                      <button class="nav-link" id="apartments-tab" type="button" (click)="offlineClick(3)"><i class="fas fa-arrows-rotate" style="padding-right: 10px;"></i> Reissue</button>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }


          @if (selectedMainDiv === 2) {
            <div class="pnr-popup fhid">
              <div class="flight-type-wrapper menu">
                <label class="radio" id="onetriptypeclick">
                  <input type="radio" [checked]="selectedDiv === 1" name="flight-type" value="Galileo">
                  <span class="radio-btn"></span>
                  <span class="flight-type-text">Galileo</span>
                </label>
              </div>
              <hr />
              @if (navMenu?.importPnr === true) {
                <div>
                  <div class="row m-0">
                    <div class="import_btn_container">
                      <div class="flex-container">
                        <div class="importFields">
                          <div>
                            <h6 class="pnr-search">PNR<span class="asteric">*</span></h6>
                            <input type="text" class="pnr-input" name="importpnr" [(ngModel)]="importPNR.pnr" />
                          </div>
                          <!--<div class="col-md-2">
                        </div>-->
                        <div class="col-md-5">
                          <h6 class="pnr-search">PCC<span class="asteric">*</span></h6>
                          <ng-select #oficeId [items]="pccList$ | async"
                            name="importpcc"
                            class="multiselect newvoidofice pcc-input"
                            bindLabel="officeId"
                            bindValue="officeId"
                            [searchable]="true"
                            [(ngModel)]="importPNR.bookingPccCode"
                            style="border:1px solid black !important">
                          </ng-select>
                        </div>
                        <div class="col-md-2">
                          <button (click)="importButton()" type="button" class="pnr-btn" style="margin-top: 24px;">Import</button>
                        </div>
                      </div>
                    </div>
                    <div class="loaders" id="loaderissue">
                      <img src="../../assets/img/IMPORTPNRLOADER.svg" style="height: 50px;" />
                    </div>
                  </div>
                </div>
                <div style="color:red;font-weight:bold;font-size:12px;" class="row m-0">
                  <span style="margin-left:15px" id="importpnridmessage"></span>
                </div>
              </div>
            }
            <div class="content">
              <div class="content_sub">
                <span><i class="uil uil-circle"></i></span>
                <h4 class="desc1">Create a PNR in your own PCC, do a fare quote and Queue it to us in given PCC.</h4>
              </div>
              <div class="content_sub">
                <span><i class="uil uil-circle"></i></span>
                <h4 class="desc1">
                  Now you can retrieve your PNR on our Website and issue the ticket, using this
                  option.
                </h4>
              </div>
              <div class="content_sub">
                <span><i class="uil uil-circle"></i></span>
                <h4 class="pnr-descp">
                  Our system will price the PNR, accepts the terms and condition and click on
                  submit to get ticketed. Please confirm the fare before queuing to us and rechecked by retrieving
                  Booking.
                </h4>
              </div>
              @if (!isPakistan) {
                <div>
                  <table class="pnr-table">
                    <thead class="pnr-head">
                      <tr class="pnr-tr">
                        <th class="pnr-th" colspan="6">Galileo</th>
                      </tr>
                      <tr>
                        <!--<th class="pnr-th ">SupplierId</th>-->
                        <th class="pnr-th" style="text-align: center;">PCC</th>
                        <th class="pnr-th" style="text-align: center;">Airline</th>
                        <th class="pnr-th" style="text-align: center;">Entry</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (obj of importPnrEntryList$; track obj) {
                        <tr>
                          <!--<td class="pnr-td">{{obj.supplier}}</td>-->
                          <td class="pnr-td" style="text-align: center;">{{obj.pcc}}</td>
                          <td class="pnr-td" style="text-align: center;">{{obj.airline}}</td>
                          <td class="pnr-td" style="text-align: center;">{{obj.entry}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (isPakistan) {
                <div>
                    ="
                    <table class="pnr-table">

                      <thead class="pnr-head">
                        <tr class="pnr-tr">
                          <th class="pnr-th" colspan="6">Galileo</th>
                        </tr>
                        <tr>
                          <!--<th class="pnr-th "  >SupplierId</th>-->
                          <th class="pnr-th" style="text-align: center;">PCC</th>
                          <th class="pnr-th" style="text-align: center;">Airline</th>
                          <th class="pnr-th" style="text-align: center;">Entry</th>
                        </tr>

                      </thead>
                      <tbody>
                        @for (obj of importPnrEntryList$; track obj) {
<tr>
                          <!--<td class="pnr-td">{{obj.supplier}}</td>-->

                          <td class="pnr-td" style="text-align: center;">{{obj.pcc}}</td>
                          <td class="pnr-td" style="text-align: center;">{{obj.airline}}</td>
                          <td class="pnr-td" style="text-align: center;">{{obj.entry}}</td>
                        </tr>
}



                      </tbody>


                    </table>
                  </div>
}

                </div>



              </div>
}

              <!--</div>-->
            </div>
          </div>

          <div class="main_card">

            <!---->
            @if (groupTicketShowRightCMS.showGroupTicket) {
<div class="groupOffersMain"
                 style="flex-direction: row !important; scrollbar-color: orange white; ">
        @for (ticket of groupTicketList; track ticket; let i = $index) {
          <div class="groupOffers">
            <div class="ribbon4" style="color: white !important;">Special Offer</div>
            <div class="groupCards">
              <div class="groupCardMainOut " style="width: 60% !important;">
                <div class="groupCardMain">
                  <div class="groupCardFrom " style="width: 20%;">
                    <span class="groupCardIATA" style="color: black !important; font-size: 13px !important;">{{ticket.onewayFromAirport}}</span>
                  </div>
                  <div class="groupCardCenter" style="width: 40%;">
                    <img style="height: 20px; width: 100%;" src="assets/img/animation_fly.gif" alt="Travels">
                  </div>
                  <div class="groupCardTo" style="width: 20%;">
                    <span class="groupCardIATA " style="color: black !important; font-size: 13px !important;">{{ticket.onewayToAirport}}</span>
                  </div>
                </div>
                <div class="groupCardDate" style="font-size: 9px;color: black !important;">
                  {{ticket.departureDate|date:'dd-MMM-yyyy'}}
                </div>
                @if (ticket.returnFromAirport!='') {
                  <div class="groupCardBorder"></div>
                }
                @if (ticket.returnFromAirport!='') {
                  <div class="groupCardMain">
                    <div class="groupCardFrom" style="width: 20%;">
                      <span class="groupCardIATA" style="color: black !important; font-size: 13px !important;">{{ticket.returnFromAirport}}</span>
                    </div>
                    <div class="groupCardCenter" style="width: 40%;">
                      <img style="height: 20px; width: 100%; transform: rotate(-180deg);"
                        src="assets/img/animation_fly.gif" alt="Travels">
                      </div>
                      <div class="groupCardTo" style="width: 20%;">
                        <span class="groupCardIATA" style="color: black !important; font-size: 13px !important;">{{ticket.returnToAirport}}</span>
                      </div>
                    </div>
                  }
                  @if (ticket.returnFromAirport!='') {
                    <div class="groupCardDate" style="font-size: 9px; color: black !important;">
                      {{ticket.returnDate|date:'dd-MMM-yyyy'}}
                    </div>
                  }
                </div>
                <div class="groupBatch " style="width: 40%;">
                  <div class="groupBatchOuter " style="width: 40px; height: 40px; background-color: #ffaa00; text-align:center;" (click)="GroupTicketClick(i)">
                    <span class="groupBatchText" style="color: white !important; font-size: 7px;">{{ticket.tripType}}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }



    </div>

  </form>
</div>
</div>
</div>

</main>

<p-dialog header="Notice"
  [(visible)]="primeShowModal"
  [modal]="true" [position]="position"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false" >
  @for (noti of activeNotification; track noti) {
    <div >
      <dx-html-editor valueType="html" [readOnly]="true" class="main_noti" [(ngModel)]="noti.notiDescription"></dx-html-editor>
    </div>
  }
</p-dialog>
